import { FC } from 'react';
import { JsonViewer } from '../JsonViewer';
import { Props } from './types';
import classes from './JSONOutput.module.scss';

export const JSONOutput: FC<Props>  = ({ processingData }) => {
  return (
    <div className={classes.wrapper}>
      <JsonViewer inputValue={processingData} isLast />
    </div>
  )
};
